import { getSyiSlice } from 'tradera/apps/syi/state/selectors/syi';
import type { RootState } from 'tradera/state/configure-store';

export const selectIsClassificationPending = (state: RootState) =>
    getSyiSlice(state).predictions.isClassificationPending;

export const selectCanGetPredictionFromImages = (state: RootState) =>
    getSyiSlice(state).predictions.canGetPredictionFromImages;

export const selectClassificationResponse = (state: RootState) =>
    getSyiSlice(state).predictions.classification;

export const selectIsLoadingPredictions = (state: RootState) =>
    getSyiSlice(state).predictions.isLoadingPredictions;

export const selectPredictedShortDescription = (state: RootState) =>
    getSyiSlice(state).predictions.shortDescription;

export const selectPredictedLongDescription = (state: RootState) =>
    getSyiSlice(state).predictions.longDescription;

export const selectShouldSuggestShortDescription = (state: RootState) =>
    getSyiSlice(state).predictions.shouldSuggestShortDescription;

export const selectShouldSuggestLongDescription = (state: RootState) =>
    getSyiSlice(state).predictions.shouldSuggestLongDescription;

export const selectHasUsedPredictedDescription = (state: RootState) =>
    getSyiSlice(state).predictions.hasUsedPredictedDescription;

export const selectHasUsedAutoFill = (state: RootState) =>
    getSyiSlice(state).predictions.hasUsedAutoFill;
